<template>
  <div style="width: 100%;height: 100vh;overflow-y: scroll;">
    <div class="tip" v-if="msg == ''">
      <img src="https://down.baoanlailou.com/00/icon.png" alt="" />
      <div>禁止对身高/体重造假，造假会根据平台规章协议实行经济赔偿</div>
    </div>
    <div class="tip" v-if="msg != ''">
      <img src="https://down.baoanlailou.com/00/icon.png" alt="" />
      <div>{{ msg }}</div>
    </div>
    <div class="step">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div :class="[index == active ? 'icon1' : 'icon']"></div>
        <div :class="['itemName', index == active ? 'itemName1' : '']">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="title">接单条件填写</div>
    <div class="box">
      <div class="confirmItem">
        <div>身高(厘米)</div>
        <el-input
          placeholder="请输入正确的身高，如172。身高填写错误将影响收入结算"
          v-model="height"
        >
        </el-input>
      </div>
      <div class="confirmItem">
        <div>体重(公斤)</div>
        <el-input
          placeholder="请输入体重，如65。体重填写错误将影响收入结算"
          v-model="weight"
        >
        </el-input>
      </div>
    </div>
    <div class="title">基础信息</div>
    <div class="box">
      <div class="confirmItem">
        <div>姓名</div>
        <el-input placeholder="请输入" v-model="name" disabled></el-input>
      </div>
      <div class="confirmItem">
        <div>性别</div>
        <!-- <el-select
          v-model="sex"
          placeholder="请选择"
          style="width: 100%;"
          disabled
        >
          <el-option label="男" value="0"> </el-option>
          <el-option label="女" value="1"> </el-option>
        </el-select> -->
        <el-input :placeholder="sex == 0 ? '男' : '女'" disabled v-model="sex">
        </el-input>
      </div>
      <div class="confirmItem">
        <div>身份证号码</div>
        <el-input placeholder="请输入" v-model="IDcode" disabled> </el-input>
      </div>
      <div class="confirmItem">
        <div>保安证号</div>
        <el-input placeholder="请输入" v-model="code"> </el-input>
      </div>
    </div>
    <div class="title">保安证信息</div>
    <div class="box1">
      <div style="width: 100%;">
        <img :src="img1" alt="" class="img" />
        <div class="info1">保安证照片</div>
      </div>
    </div>
    <div class="title">身份证信息</div>
    <div class="box1">
      <div style="width: 325px;">
        <img :src="img2" alt="" class="img1" />
        <div class="info1">身份证人像面</div>
      </div>
      <div style="width: 325px;">
        <img :src="img3" alt="" class="img1" />
        <div class="info1">身份证国徽面</div>
      </div>
    </div>
    <div class="btnBox">
      <div class="btn1" @click="save">确认保存</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 2,
      list: [
        {
          name: "绑定手机号"
        },
        {
          name: "认证保安证"
        },
        {
          name: "认证身份证"
        },
        {
          name: "信息确认"
        }
      ],
      height: "",
      weight: "",
      IDcode: "",
      code: "",
      name: "",
      sex: "",
      img1: "",
      img2: "",
      img3: "",
      pageData: {},
      msg: "",
      canClick: true
    };
  },
  mounted() {
    this.msg = localStorage.getItem("errorMsg");
    let data = JSON.parse(localStorage.getItem("baBodyguardsInfoVO"));
    if (localStorage.getItem("errorMsg") != "") {
      this.height = data.high;
      this.weight = data.weight;
    }
    let obj = this.$route.query;
    this.code = obj.proveData.code;
    this.img1 = obj.proveData.img;
    this.img2 = obj.identity.img;
    this.img3 = obj.identity.img1;
    this.name = obj.identity.name;
    this.sex = obj.identity.sex == 1 ? "男" : "女";
    this.IDcode = obj.identity.cardCode;
    this.pageData = obj;
  },
  methods: {
    save() {
      if (this.canClick == false) {
        return;
      }
      // if (this.height == "") {
      //   this.$message({
      //     message: "请输入身高",
      //     type: "warning"
      //   });
      //   return;
      // }
      // if (this.height * 1 < 60 || this.height * 1 > 500) {
      //   this.$message({
      //     message: "您填写的身高不符合要求",
      //     type: "warning"
      //   });
      //   return;
      // }
      // if (this.weight == "") {
      //   this.$message({
      //     message: "请输入体重",
      //     type: "warning"
      //   });
      //   return;
      // }
      // if (this.weight * 1 < 10 || this.weight * 1 > 500) {
      //   this.$message({
      //     message: "您填写的体重不符合要求",
      //     type: "warning"
      //   });
      //   return;
      // }

      let param = {
        bodyguardCard: this.img1,
        bodyguardCardCode: this.code,
        cardFrontUrl: this.img2,
        cardBackUrl: this.img3,
        high: this.height,
        weight: this.weight,
        cardType: 1
      };
      this.canClick = false;
      this.$axios
        .post(`/mapi/api/common/invite/accountSave`, param)
        .then(({ data }) => {
          this.$message({
            message: "注册成功",
            type: "success"
          });
          this.$router.push({
            path: "/poster",
            query: {
              useType: 1
            }
          });
        })
        .catch(error => {
          this.canClick = true;
        })
        .finally();
    }
  }
};
</script>
<style scoped>
.tip {
  height: 27px;
  width: 100%;
  background: #fff3d9;
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff6f23;
  line-height: 27px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;
}
.tip img {
  display: block;
  margin-right: 6px;
  flex: none;
  width: 12px;
  height: 12px;
}
.step {
  width: 100%;
  padding: 16px 18px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
}
.item {
  text-align: center;
  padding: 0 8px;
  box-sizing: border-box;
  position: relative;
}
.icon {
  width: 8px;
  height: 8px;
  background: #ccd9e9;
  border-radius: 4px;
  margin: 0 auto 10px;
}
.item::after {
  content: "";
  width: 85px;
  height: 1px;
  background: #ccd9e9;
  position: absolute;
  top: 4px;
  left: 40px;
}
.step :last-child::after {
  display: none;
}
.icon1 {
  width: 8px;
  height: 8px;
  border: 1px solid #02b6fc;
  border-radius: 4px;
  margin: 0 auto 10px;
  box-sizing: border-box;
}
.itemName {
  font-size: 12px;
  font-weight: 400;
  color: #94a4b7;
  line-height: 16px;
}
.itemName1 {
  color: #02b6fc;
}
.title {
  width: 100%;
  padding: 7px 10px;
  box-sizing: border-box;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #111111;
  line-height: 16px;
  background: #f5f7fa;
}
.box {
  padding: 0 12px;
  box-sizing: border-box;
}
.confirmItem {
  height: 73px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #111111;
  line-height: 12px;
  padding: 13px 0 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e8ecef;
}
.box1 {
  width: 100%;
  padding: 20px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.img {
  width: 100%;
  height: 205px;
  border-radius: 10px;
}
.info1 {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
  line-height: 16px;
  margin-top: 10px;
}
.img1 {
  width: 100%;
  height: 102px;
  border-radius: 10px;
}
.btnBox {
  display: flex;
  justify-content: space-between;
  padding: 0 27px;
  box-sizing: border-box;
  margin: 15px 0;
}
.btn {
  text-align: center;
  width: 151px;
  height: 44px;
  border-radius: 22px;
  border: 1px solid #979797;
  font-size: 15px;
  font-weight: 400;
  color: #000;
  line-height: 44px;
}
.btn1 {
  text-align: center;
  width: 100%;
  height: 44px;
  background: #1677ff;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 400;
  color: #fff;
  line-height: 44px;
}
</style>
<style>
.el-input.is-disabled .el-input__inner {
  color: #000 !important;
  font-weight: 600;
  font-size: 12px;
}
.el-input {
  width: 100%;
  height: 100% !important;
  font-size: 12px;
}
.el-input__inner {
  height: 100% !important;
  background: transparent !important;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  line-height: 50px;
  padding: 15px 0;
  box-sizing: border-box;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/comfirm/confirm.vue